"use client"

export default function BoilerplateTechnologyDetails({
  name,
  icon,
}: {
  name: string
  icon: any
}) {
  return (
    <li className="flex items-center gap-2 rounded-md w-fit bg-neutral-200 px-4 h-[48px] font-medium">
      {icon}
      <span className="text-main-black">{name}</span>
    </li>
  )
}
